class OrderDetailsModel {
  id: any
  token: string = ""
  clientId: any
  payLater: any
  clubMember: any
  status: string = ""
  totalAmount: number = 0
  totalDeliveryCost: number = 0
  totalStorageCost: number = 0
  deliveries: OrderDelivery[] = []
  town: string = ""
  district: string = ""
  unit: string = ""
  street: string = ""
  pickup: boolean = false
  deliveryNote: string | null = null
  company: CompanyModel = new CompanyModel()
}

class OrderDelivery {
  id: any
  orderId: any
  date: any
  cost: Number = 0
  items: any[] = []
}

class CompanyModel {
  name: string = ""
  phone: string = ""
  register: string = ""
  town: string = ""
  district: string = ""
  unit: string = ""
  street: string = ""
}

export default OrderDetailsModel